import * as services from './generated/api/sdk.gen';

export const useExperienceApi = () => services;
